// Tiny shared haptic helper for tournament (and other) touch interactions.
// Mirrors the inline navigator.vibrate guard already used in the Navbar drag
// buttons (DraggableMenuButton/ActionButton/etc.) — no new dependency, just the
// browser Vibration API. iOS Safari ignores navigator.vibrate (Apple restricts
// haptics to native UI), so visual feedback stays the primary signal and the
// buzz is a bonus on devices that support it; unsupported browsers no-op.
export const triggerHaptic = (ms = 40) => {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(ms);
    }
  } catch {
    /* unsupported — ignore */
  }
};

export default triggerHaptic;
